import { THEME_LIST, DEFAULT_THEME_INDEX } from "@/constants/setting.js";

export default {
  setting: {
    theme: THEME_LIST[DEFAULT_THEME_INDEX]
  }
}
